import React from 'react';
import { motion } from 'framer-motion';
import { ScaleIcon } from 'lucide-react';
export function CostOfInaction() {
  const costs = [{
    problem: 'Seguir mirando cómo otros venden velas comestibles',
    cost: 'El mercado se satura y perdés la ventaja'
  }, {
    problem: 'Sin fórmula de precios',
    cost: 'Trabajás horas y no ganás nada'
  }, {
    problem: 'Packaging armado con lo que tenés',
    cost: 'Vergüenza de mostrar el producto'
  }, {
    problem: 'Sin sistema de redes',
    cost: 'Nunca llegás a nuevos clientes'
  }, {
    problem: 'Sin la línea salada ni la premium',
    cost: 'Perdés clientes de eventos y restaurantes'
  }, {
    problem: 'Otro mes sin animarte a arrancar',
    cost: 'El mismo ciclo, el mes que viene'
  }];
  return <section className="w-full bg-neutral-950 py-4 md:py-8" data-id="element-32">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-34">
          <div className="text-center mb-3 md:mb-6" data-id="element-35">
            <div className="flex justify-center mb-2 md:mb-3" data-id="element-36">
              <div className="bg-rose-500/10 p-3 rounded-full" data-id="element-37">
                <ScaleIcon className="w-10 h-10 text-rose-400" data-id="element-38" />
              </div>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-amber-50 mb-1 md:mb-2" data-id="element-39">
              ⚖️ ¿CUÁNTO TE CUESTA NO TENERLO?
            </h2>
          </div>

          <div className="bg-neutral-900 border border-rose-900/40 rounded-lg overflow-hidden mb-3 md:mb-5" data-id="element-40">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 p-3 bg-neutral-950 border-b border-rose-900/40" data-id="element-41">
              <div className="font-bold text-amber-50 text-sm" data-id="element-42">
                Sin el Mega Pack
              </div>
              <div className="font-bold text-rose-400 text-sm" data-id="element-43">Costo real</div>
            </div>

            {costs.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.4
          }} className="grid grid-cols-1 md:grid-cols-2 gap-3 p-3 border-b border-rose-900/40 last:border-b-0" data-id="element-44">
                <div className="text-neutral-300 text-sm" data-id="element-45">{item.problem}</div>
                <div className="text-rose-400 font-semibold text-sm" data-id="element-46">
                  {item.cost}
                </div>
              </motion.div>)}
          </div>

          <motion.h3 initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-2xl md:text-4xl font-bold text-amber-400 text-center" data-id="element-47">
            La próxima semana puede ser diferente.
          </motion.h3>
        </motion.div>
      </div>
    </section>;
}